import { Controller } from "@hotwired/stimulus"
// import intlTelInput from "intl-tel-input"
import de from "intl-tel-input/i18n/de"
import intlTelInput from "intl-tel-input/intlTelInputWithUtils"


// Connects to data-controller="phone-number"
export default class extends Controller {
  static targets = [ 'input' ]
  static values = {
    currentNumber: String,
    id: String,
    fieldName: String
  }

  initialize () {
    this.field = intlTelInput(this.inputTarget, {
      loadUtilsOnInit: "/assets/intlTelInputUtils.js",
      // loadUtilsOnInit: () => import("intl-tel-input/intlTelInputWithUtils"),
      countryOrder: [ 'ch', 'li', 'at', 'de', 'it', 'fr' ],
      nationalMode: false,
      separateDialCode: true,
      strictMode: true,
      formatAsYouType: true,
      formatOnDisplay: true,
      containerClass: 'w-full',
      i18n: de,
      customPlaceholder: function (selectedCountryPlaceholder, _selectedCountryData) {
        return selectedCountryPlaceholder
      }
    })

    this.inputHandler = () => this.validateWhileTyping()

    // console.log(this.idValue, this.field)
    // this.field.value = document.getElementById(this.targetIdValue).value
  }

  connect () {
    this.inputTarget.addEventListener("keyup", this.inputHandler)
    this.inputTarget.addEventListener("change", this.inputHandler)
    this.inputTarget.addEventListener("input", this.inputHandler)
    this.inputTarget.addEventListener("blur", this.inputHandler)
  }

  disconnect () {
    this.inputTarget.removeEventListener("keyup", this.inputHandler)
    this.inputTarget.removeEventListener("change", this.inputHandler)
    this.inputTarget.removeEventListener("input", this.inputHandler)
    this.inputTarget.removeEventListener("blur", this.inputHandler)
  }

  validateWhileTyping () {
    console.log('*** telefon input', this, this.field, `${ this.idValue }_target`, this.field.getNumber())

    if (this.field.isValidNumber()) {
      this.inputTarget.classList.add("text-green-600")
    } else {
      this.inputTarget.classList.add("text-red-600")
    }

    document.getElementById(`${this.idValue}_target`).value = this.field.getNumber()
  }

  // initialize () {
  //   // const elem = document.querySelector(`#${ this.idValue }`)
  //   console.log('phone-number connected', this.element, this.idValue)
  //
  //   this.inputField = intlTelInput(this.element, {
  //     utilsScript: "/intl-tel-input/utils.js",
  //     countryOrder: [ 'ch', 'li', 'at', 'de', 'it', 'fr' ],
  //     // separateDialCode: false,
  //     strictMode: true,
  //     // formatAsYouType: true,
  //     containerClass: 'w-full',
  //     i18n: de,
  //     nationalMode: true
  //   })
  //
  //   // preferredCountries: [ 'ch', 'li', 'at', 'de', 'it', 'fr' ],
  //   // utilsScript: 'utils.js',
  //   // localizedCountries
  //   // })
  //
  //   // if (this.currentNumberValue !== '') {
  //   //   this.inputField.setNumber(this.currentNumberValue)
  //   // }
  // }
}
